export default {
  signup: {
    propertyName: 'isNoCovid19Confirmed',
    daysToAdd: 14,
    message1: 'Important! Please help us keep people safe by not booking any technician visits to occur within the '
      + 'next 14 days if there is someone in self-isolation, or with Coronavirus symptoms at the connection address. '
      + 'If this is the case, your connection date cannot be earlier than 14 days from today. Technicians will confirm '
      + 'this onsite and additional precautions will be taken.',
    message2: 'Please select below:',
    label: 'No Coronavirus symptoms at my place',
    isEssentialService: {
      label: 'I am in essential business/service'
    },
    essentialServiceType: {
      placeholder: 'Select the category of your business/service',
      label: 'Category of business/service',
      types: [
        { value: 'Civil Defense', label: 'Civil Defense' },
        { value: 'Essential Business', label: 'Essential Business' },
        { value: 'Education', label: 'Education' }
      ]
    },
    essentialServiceReason: {
      placeholder: 'Enter the full details of your role and how Fibre will support your business/service, e.g. I am '
        + 'the manager of a team of 20 and a fast connection will support online meetings with many participants',
      label: 'Full details of your role in your business/service and why Fibre is important'
    },
    chorusMessage1: 'We will book an appointment date after ',
    chorusMessage2: ', and we will escalate your case to the line provider to reschedule your connection date to '
      + 'the earliest possible date.'
  },
  dashboard: {
    title: 'Important notice about COVID-19',
    message: 'Are you unwell with a fever or dry cough? Have you been overseas in the last 14 days or near someone who '
      + 'could have COVID-19 or the Coronavirus? Please help us keep people safe and stop the spread of Coronavirus by '
      + 'not booking any technician visits to occur within the next 14 days and until you’re feeling well.'
  }
};



/** WEBPACK FOOTER **
 ** ./src/common/Covid19Constants.js
 **/